<template>
    <v-dialog v-model="dialog" max-width="500" @click:outside="hide">
        <v-card class="card-container">
            <v-card-title class="title-container">
                <v-icon color="#FFFFFF" @click="hide" large class="mr-3">mdi-close-circle-outline</v-icon>
                {{ editMode ? $t('common.edit') : $t('common.add') }} {{ $t('common.competence') }}
            </v-card-title>
            <v-card-text class="mt-3">
                <v-row>
                    <v-col cols="12" v-if="selectDate">
                        <kimsa-date-picker :label="$t('routines.from')" solo flat dense outlined color="secondary"
                        @change="date = $event" :value="date" ref="start" bolder-label/>
                    </v-col>
                    <v-col cols="12">
                        <kimsa-text-field outlined no-elevation bolder-label dense :label="$t('common.versus_short')"
                            @change="versus = $event" :value="versus" force-value />
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions class="px-0 pb-0">
                <v-row no-gutters>
                    <v-col cols="12">
                        <v-btn block depressed x-large color="primary" class="normal-btn no-radius black--text"
                            :disabled="disabled" @click="setCompetence" :loading="loading">
                            {{ $t('common.save') }}
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card-actions>
        </v-card>

    </v-dialog>
</template>

<script>
import KimsaTextField from "@/components/common/inputs/KimsaTextField";
import { db } from "@/utils/Firebase";
import { mapMutations, mapState } from "vuex";
import { addAssignedCompetenceGroup, deleteAssignedRoutinesGroup, getPayloadBaseAssignedCompetence, updateAssignedCompetenceGroup } from "../../../utils/Exercises";
import KimsaDatePicker from '../../common/inputs/KimsaDatePicker.vue';

export default {
    name: "AddCompetenceDialog",
    components: { KimsaTextField, KimsaDatePicker },
    props: {
        currentSelection: {
            type: Object,
            default: null,
        },
        collection: {
            type: String,
            default: null,
        },
        assignedRoutineToReplace: {
            type: Array,
            default: () => [],
        },
        coachId: {
            type: String,
            default: null,
        },
        selectDate: {
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {
            dialog: false,
            loading: false,
            versus: '',
            date: null,
            editMode: false,
            competence: null,
        }
    },
    computed: {
        ...mapState(['dialogActive']),
        disabled(vm = this) {
            return !vm.versus
        },
        competenceId(vm = this) {
            return vm.competence?.id || null
        },
    },
    methods: {
        ...mapMutations(['setDialogActive']),
        show(date, competence = null) {
            const vm = this
            vm.setDefaults(competence, date)
            vm.dialog = true
            vm.setDialogActive(true)
        },
        hide() {
            const vm = this
            vm.dialog = false
            vm.setDialogActive(false)
            vm.reset()
        },
        reset() {
            const vm = this
            vm.competence = null
            vm.versus = ''
            vm.date = null
            vm.editMode = false
        },
        setDefaults(competence, date) {
            const vm = this
            vm.date = date
            vm.competence = competence
            vm.versus = competence?.versus || ''
            vm.editMode = !!vm.versus
        },
        async setCompetence() {
            const vm = this
            vm.loading = true

            if (vm.selectDate) {
                let routineRef = await db.collection(vm.collection).where('studentId', '==', vm.currentSelection.objectID).where('rawDate.full', '==', vm.date).get()
                if (routineRef.docs.length > 0) {
                    vm.toast(vm.$t('common.busy_date_competence'), 'error')
                    return vm.loading = false;
                }
            }

            if (vm.editMode) {
                await db.collection(vm.collection).doc(vm.competence.id).update({ versus: vm.versus })
                if (vm.collection === 'groupAssignedRoutines') await updateAssignedCompetenceGroup(assignedRoutineData.assignedRoutinesIds, vm.versus)
            } else {
                let payloadCompetence = getPayloadBaseAssignedCompetence(vm.versus, vm.date, vm.coachId)

                if (vm.collection === 'assignedRoutines') {
                    payloadCompetence.studentId = vm.currentSelection.objectID
                } else {
                    payloadCompetence.teamId = vm.currentSelection.teamId || null
                    payloadCompetence.groupId = vm.currentSelection.id
                }

                const arRef = await db.collection(vm.collection).add(payloadCompetence)
                const competenceId = arRef.id
                vm.competence = payloadCompetence

                if (vm.collection === 'groupAssignedRoutines') {
                    let students = [...vm.currentSelection.students]
                    if (vm.assignedRoutineToReplace.length > 0) {
                        let toDelete = vm.assignedRoutineToReplace.filter(ar => ar.replace).map(ar => {
                            return ar.assignedRoutineId
                        })
                        if (toDelete.length > 0) await deleteAssignedRoutinesGroup(toDelete)
                        let skippedStudents = vm.assignedRoutineToReplace.filter(ar => !ar.replace).map(ar => {
                            return ar.studentId
                        })
                        if (skippedStudents.length > 0) students = students.filter(st => !skippedStudents.includes(st))
                    }
                    await addAssignedCompetenceGroup({ id: competenceId, ...payloadCompetence, date: vm.date }, students)
                }
            }

            vm.loading = false
            vm.toast(vm.$t('common.competence_saved'))
            vm.$emit('saved', { ...vm.competence, versus: vm.versus, date: vm.date })
            vm.hide()
        },
    },
    watch: {
        dialogActive(val) {
            if (!val) this.hide()
        },
    }
}
</script>

<style scoped>
.card-container {
    border-radius: 8px;
    overflow: hidden;
}

.title-container {
    color: #FFFFFF;
    background: var(--v-backGroundPrimary-base);
}
</style>